<template>
  <div>
    <div class="modal is-active" v-show="showDeleteModal">
      <div class="modal-background"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">Delete Ticket</p>
          <button class="delete" aria-label="close"></button>
        </header>
        <section class="modal-card-body">
          Are you sure do you want to delete this ticket?
        </section>
        <footer class="modal-card-foot" style="justify-content:flex-end">
          <button :class="dangerButton" @click="deletePermanently">Delete permanently</button>
          <button class="button is-small" @click="closeModal">Cancel</button>
        </footer>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import axios from 'axios'
import AppToast from '../frontend/appToast'
import AppButton from '../frontend/appButton'

const appToast = new AppToast()
const appButton = new AppButton()

export default {
  data() {
    return {
      dangerButton: appButton.isLoadingDanger(false)
    }
  },
  computed: {
    ...mapState('ticketingforitem', {
      showDeleteModal: state => state.showDeleteModal,
      ticketingForItem: state => state.ticketingForItem
    })
  },
  methods: {
    ...mapActions('ticketingforitem', ['openDeleteModal', 'getPaginatedData']),
    deletePermanently() {
      this.dangerButton = appButton.isLoadingDanger(true)
      axios
        .delete(
          `api/ticketingforitems/${this.ticketingForItem.ticketingForItemId}`
        )
        .then(response => {
          appToast.success(response.data)
          this.default()
        })
        .catch(error => {
          console.log(error)
          if (error.response) {
            appToast.danger(error.response.data)
          }
        })
        .then(() => {
          this.dangerButton = appButton.isLoadingDanger(false)
        })
    },
    closeModal() {
      this.default()
    },
    default() {
      this.openDeleteModal({
        showDeleteModal: false
      })

      const pageFromRoute = parseInt(this.$route.params.page)
      const perPageFromRoute = parseInt(this.$route.params.pageSize)
      const searchQueryFromRoute = !this.$route.params.searchQuery ? '' : this.$route.params.searchQuery
      const bySowFromRoute = this.$route.params.sow
      const byItemTypeFromRoute = this.$route.params.itemType
      const byProgressStatFromRoute = this.$route.params.progressStat

      this.getPaginatedData({
        page: pageFromRoute,
        pageSize: perPageFromRoute,
        query: searchQueryFromRoute,
        sow: bySowFromRoute,
        itemType: byItemTypeFromRoute,
        progressStat: byProgressStatFromRoute
      })
    }
  }
}
</script>
